import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { commonService } from "../../Network/services/commonService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const PaymentPayoutTypeView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [profile, setProfile] = useState({});
  const [name, setName] = useState("");
  const [accountName, setAccountName] = useState(location.state==undefined?"":location.state.account_holder_name);
  const [accountNumber, setAccountNumber] = useState(location.state==undefined?"":location.state.account_number);
  const [confirmAccountNumber, setonfirmAccountNumber] = useState(location.state==undefined?"":location.state.account_number);
  const [bankName, setBankName] = useState(location.state==undefined?"":location.state.bank_name);
  const [ifsc, setIfsc] = useState(location.state==undefined?"":location.state.account_number);
  const [address, setAddress] = useState(location.state==undefined?"":location.state.address);
  const [accountId, setAccountId] = useState(location.state==undefined?"":location.state.id);

  const [loading, setLoading] = useState(false);
  const [walletLoading, setWalletLoading] = useState(false);

  useEffect(() => {
   
    let user = JSON.parse(window.localStorage.getItem("UserData"));

    setName(user.first_name + " " + user.last_name);
    let personal_preference_name1_array = user.personal_preference_name1.split(
      ","
    );
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.push("/bankList")
  };

  const redirect = () => {
    history.push("/ExperienceUpdate");
  };
  const addaccount = () => {
    setLoading(true)
    const FormData = require("form-data");

    const form = new FormData();
    form.append("account_number", accountNumber);
    form.append("confirm_account_number", confirmAccountNumber);
    form.append("ifsc_code", ifsc);
    form.append("bank_name", bankName);
    form.append("account_holder_name", accountName);
    form.append("address", address);
    form.append("edit_id", accountId);

    commonService
      .CommonService("update_bank_account", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          history.goBack();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false)
      });
  };
 
  
  return (
    <section className="explore explore1">
    <div className="container">
      <div className="banner">
        <div className="row">
          <div className="col-md-4">
            <div className="breadcrumps">
            <ul>
                    <li><a href="#" onClick={(e)=>{
                   e.preventDefault();
                   history.goBack();
                }}><i className="bx bx-chevron-left" /> Back</a></li>
                  </ul>
            </div>
          </div>
       
        </div>
      </div>
      <section className="onbord-section">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className="title">Add Bank Details</h1>
                <p className="subtitle" />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="board-box board-box2 post-new-job">
                <LoadingOverlay>

                  <form>
                    <div className="form-group">
                      <label>Account Holder Name</label>
                      <input type="textbox" className="form-control" required="required" placeholder="Account Holder Name"  value={accountName}
                            onChange={(e) => {
                              setAccountName(e.target.value);
                            }}/>
                    </div>
                    <div className="form-group margin-bottom2">
                      <label>Account Number</label>
                      <input type="textbox" className="form-control" required="required" placeholder="Account Number" value={accountNumber}
                            onChange={(e) => {
                              setAccountNumber(e.target.value);
                            }} />
                    </div>
                    <div className="form-group margin-bottom2">
                      <label>Confirm Account Number</label>
                      <input type="textbox" className="form-control" required="required" placeholder="Confirm Account Number" value={confirmAccountNumber}
                            onChange={(e) => {
                              setonfirmAccountNumber(e.target.value);
                            }} />
                    </div>
                    <div className="form-group margin-bottom2">
                      <label>Bank Name</label>
                      <input type="textbox" className="form-control" required="required" placeholder="Bank Name" value={bankName}
                            onChange={(e) => {
                              setBankName(e.target.value);
                            }} />
                    </div>
                    <div className="form-group margin-bottom2">
                      <label>IFSC Code</label>
                      <input type="textbox" className="form-control" required="required" placeholder="IFSC Code" value={ifsc}
                            onChange={(e) => {
                              setIfsc(e.target.value);
                            }} />
                    </div>
                    <div className="form-group margin-bottom2">
                      <label>Address</label>
                      <input type="textbox" className="form-control" required="required" placeholder="Address" value={address}
                            onChange={(e) => {
                              setAddress(e.target.value);
                            }} />
                    </div>
                    <button onClick={(e)=>{
                      e.preventDefault()
                      addaccount()
                    }}>SUBMIT</button> <a href="#" onClick={(e)=>{
                      e.preventDefault();
                      history.goBack();
                   }}><button  >CANCEL</button></a>
                  </form>
                  <Loader loading={loading} />
                </LoadingOverlay>
                </div>
              </div>
            </div>
          </section>
    </div>
  </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPayoutTypeView);
